import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React, { useMemo } from 'react'
import { useAwardNominations } from '../../Hooks/Features/Awards/useAwardNominations'
import { Dialog } from 'primereact/dialog';
import { renderField } from '../../utils/Helper';
import { faTrashCan } from "@fortawesome/free-regular-svg-icons";
import CommanDialog from '../CommonCompo/CommanDialog/CommanDialog';
import { useCommon } from '../../Hooks/Common/useCommon';

const AwardNominations = ({ filterValues, setFilterValues, years }) => {

  const { nominations, createNominee, setCreateNominee, loader, nomineeFields, saveNominees, deleteNominee, declareWinner } = useAwardNominations({ filterValues, setFilterValues, years });
  const { getValuePermission } = useCommon();
  const addPermission = useMemo(() => !getValuePermission("awards_nominee_btn"), []);

  return (
    <div className='h-100'>
      <div className='d-flex gap-2 align-items-center justify-content-between'>
        <div className='fw-semibold fs-6'>Nominations {filterValues?.year && <span> · {filterValues?.year?.year_name}</span>}</div>
        {(filterValues?.year?.year_id && addPermission) && <button className='sk-btn sk-btn-primary m-0 bg-black text-white' onClick={() => setCreateNominee((prev) => ({ ...prev, visible: true, year_id: filterValues?.year?.year_id, category_id: filterValues?.category?.category_id, }))}><FontAwesomeIcon icon="fa-solid fa-plus" /> Nominee</button>}
      </div>
      <div className='mt-2'>
        <input className='sk-input-dd w100' placeholder='Search Nominees...' value={filterValues?.search} onChange={(e) => setFilterValues((prev) => ({ ...prev, search: e?.target?.value }))} />
      </div>
      <div className='mt-2 d-flex flex-column gap-2' style={{ height: "calc(100% - 80px)", overflowY: "auto" }}>
        {Object.keys(nominations)?.length === 0 ? <div className='d-flex justify-content-center align-items-center h-100 fw-semibold fs-6'>No nominee added!</div>
          : Object.entries(nominations)?.map(([key, values]) => (
            <div className='border rounded' key={key}>
              <div className='px-2 py-1 border-bottom d-flex align-items-center justify-content-between' style={{ backgroundColor: "#dddddd4d" }}>
                <div className='d-flex gap-3 align-items-center'>
                  <span className='text-primary px-1 rounded-pill fw-semibold' style={{ border: "1px solid #9ab1fc", backgroundColor: "#e0e8ff" }}>{key?.split("|")?.[0]}</span>
                  <span className='fw-bold fs-6'>{key?.split("|")?.[1]}</span>
                </div>
                <div>{values?.length} nominees</div>
              </div>
              <div className='p-2 d-flex flex-column gap-2'>
                {values?.map((item, idx) => (
                  <div key={idx} className='px-2 py-1 border rounded'
                    onMouseEnter={() => { if (addPermission) { setFilterValues((prev) => ({ ...prev, hoveredNominee: item })); } }}
                    onMouseLeave={() => { if (addPermission) { setFilterValues((prev) => ({ ...prev, hoveredNominee: {} })); } }}
                  >
                    <div className="d-flex align-items-center justify-content-between">
                      <div className={`${filterValues?.hoveredNominee?.nomination_id === item?.nomination_id ? "w60" : "w70"} fw-semibold d-flex align-items-center gap-2`}>
                        <span className='text-truncate' title={item?.user_display_name}>{item?.user_display_name}</span>
                        {item?.is_winner && <span className='px-2 rounded-pill' style={{ color: "#f59e0b", backgroundColor: "#fff5e5", border: "1px solid #fdedd4", fontSize: "0.75rem" }}>Winner</span>}
                      </div>
                      {(addPermission && filterValues?.hoveredNominee?.nomination_id === item?.nomination_id) &&
                        <div className='d-flex gap-2 w10 justify-content-end'>
                          {filterValues?.year?.year_id && <div className='c-pointer' onClick={(e) => { e?.stopPropagation(); setCreateNominee((prev) => ({ ...prev, visible: true, ...item, nominee_user_code: [item?.user_code] })) }}><FontAwesomeIcon icon="fa-solid fa-pen-to-square" /></div>}
                          <div className='text-danger c-pointer' onClick={(e) => { e?.stopPropagation(); setCreateNominee((prev) => ({ ...prev, delete: { confirm: true, nominee: item } })) }}><FontAwesomeIcon icon={faTrashCan} /></div>
                        </div>
                      }
                      {!getValuePermission("awards_declare_winner") && (!item?.is_winner ?
                        <div className='px-2 c-pointer rounded text-success' onClick={() => declareWinner(true, item)}>Declare winner</div>
                        :
                        <div className='px-2 c-pointer rounded text-danger' onClick={() => declareWinner(false, item)}>Revoke winner</div>
                      )}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ))}
      </div>
      <Dialog visible={createNominee?.visible} onHide={() => setCreateNominee({ visible: false })} draggable={false} header="Add Nominee" className='modal-xsmall'>
        <div>
          {nomineeFields?.map((field, index) => (
            renderField(field, index, (e) => { setCreateNominee((prev) => ({ ...prev, [field?.name]: e?.target?.value, isChange: true })); }, createNominee)
          ))}
          <div className='d-flex gap-1 justify-content-end'>
            <button className='sk-btn sk-btn-primary' onClick={() => setCreateNominee({ visible: false })}>Cancel</button>
            {loader?.btn ?
              <button className="sk-btn sk-btn-primary bg-black text-white" style={{ width: "107px" }}>
                <div className="spinner-border" role="status" style={{ width: "12px", height: "12px" }}>
                  <span className="sr-only"></span>
                </div>
              </button> :
              <button className='sk-btn sk-btn-primary bg-black text-white' onClick={() => saveNominees()}>Save Nominee</button>
            }
          </div>
        </div>
      </Dialog>

      <CommanDialog visible={createNominee?.delete?.confirm} handleClose={() => setCreateNominee({ visible: false })} handleFun={() => deleteNominee()} message={`Are you sure you want to delete the nominee: ${createNominee?.delete?.nominee?.user_display_name || ""}?`} loader={loader?.delete} />
    </div>
  )
}

export default AwardNominations